export default __webpack_public_path__ + "static/media/q9_step1.074aa617.png";